import { render, staticRenderFns } from "./EquipmentStepBlock.vue?vue&type=template&id=2ffb036e&scoped=true"
import script from "./EquipmentStepBlock.vue?vue&type=script&lang=js"
export * from "./EquipmentStepBlock.vue?vue&type=script&lang=js"
import style0 from "./EquipmentStepBlock.vue?vue&type=style&index=0&id=2ffb036e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffb036e",
  null
  
)

export default component.exports